<template>
  <p class="c-label" :id="index">
    <span>{{ index }}</span>
    {{ label }}
  </p>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.c-label {
  font-size: 17px !important;
  font-weight: bold !important;
  display: block !important;
  padding: 0 !important;
  margin: 0;
  span {
    margin-right: 3px;
  }
}
</style>
